import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-1bc791bc");

var _hoisted_1 = {
  key: 0,
  class: "division"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("p", {
  class: "division-title"
}, "更多精彩活动", -1);

var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = {
  class: "list-wrapper"
};
var _hoisted_5 = {
  key: 0,
  class: "commodity-list"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_list_other_activity_item = _resolveComponent("list-other-activity-item");

  var _component_van_list = _resolveComponent("van-list");

  var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");

  return _openBlock(), _createElementBlock("div", null, [$data.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_pull_refresh, {
    modelValue: $data.refreshing,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.refreshing = $event;
    }),
    onRefresh: $options.onRefresh
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_list, {
        modelValue: $data.loading,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return $data.loading = $event;
        }),
        finished: $data.finished,
        onLoad: $options.onLoad
      }, {
        default: _withCtx(function () {
          return [$data.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, function (item, id) {
            return _openBlock(), _createElementBlock("li", {
              key: id
            }, [_createVNode(_component_list_other_activity_item, {
              item: item
            }, null, 8, ["item"])]);
          }), 128))])])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue", "finished", "onLoad"])];
    }),
    _: 1
  }, 8, ["modelValue", "onRefresh"])])]);
}